'use es6';

import createAction from 'flux-actions/createAction';
import { REQUESTED_CMS_USER_SETTINGS, RECEIVED_CMS_USER_SETTINGS, REQUESTED_CMS_USER_SETTINGS_FAILED } from './ActionTypes';
export const requestedCmsUserSettings = createAction(REQUESTED_CMS_USER_SETTINGS);
export const receiveCmsUserSettings = createAction(RECEIVED_CMS_USER_SETTINGS, userSettings => ({
  userSettings
}));
export const requestedCmsUserSettingsFailed = createAction(REQUESTED_CMS_USER_SETTINGS_FAILED, error => ({
  error
}));